import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["customTag"];

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { typographyBody1, wordBreak } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledCardContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyBody1(theme);
}, wordBreak);

var CardContent = function CardContent(_ref2) {
  var customTag = _ref2.customTag,
      other = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(StyledCardContent, _objectSpread({
    as: customTag
  }, other));
};

CardContent.displayName = "CardContent";
CardContent.propTypes = {
  /** Ability to supply a different element instead of the default one */
  customTag: PropTypes.elementType
};
CardContent.defaultProps = {
  customTag: undefined
};
export { CardContent };